import { render, staticRenderFns } from "./ZoomSlider.vue?vue&type=template&id=5c06d747&scoped=true&"
import script from "./ZoomSlider.vue?vue&type=script&lang=ts&"
export * from "./ZoomSlider.vue?vue&type=script&lang=ts&"
import style0 from "./ZoomSlider.vue?vue&type=style&index=0&id=5c06d747&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c06d747",
  null
  
)

export default component.exports